export function validateConnectorOrbit(orbit) {
    if (orbit.center.length !== 3 || !orbit.center.every(Number.isFinite) || !Number.isFinite(orbit.durationSeconds) || orbit.durationSeconds <= 0
        || !/^[a-z][a-z0-9-]*$/.test(orbit.afterCue)
        || !['xy', 'xz', 'yz'].includes(orbit.plane) || !['from', 'to', 'both'].includes(orbit.endpoints)) {
        throw new Error('Connector orbit requires a finite center, positive duration, cue, plane and endpoint selection.');
    }
}
function axes(orbit) {
    return orbit.plane === 'xy' ? [0, 1] : orbit.plane === 'xz' ? [0, 2] : [1, 2];
}
export function resolveConnectorOrbitEndpoints(start, end, orbit, seconds) {
    const [a, b] = axes(orbit);
    const progress = Math.max(0, Math.min(1, seconds / orbit.durationSeconds));
    if (progress === 0 || progress === 1)
        return { start, end };
    const angle = progress * Math.PI * 2;
    const cosine = Math.cos(angle);
    const sine = Math.sin(angle);
    const rotate = (point) => {
        const result = [...point];
        const x = point[a] - orbit.center[a];
        const y = point[b] - orbit.center[b];
        result[a] = orbit.center[a] + x * cosine - y * sine;
        result[b] = orbit.center[b] + x * sine + y * cosine;
        return result;
    };
    return {
        start: orbit.endpoints === 'to' ? start : rotate(start),
        end: orbit.endpoints === 'from' ? end : rotate(end),
    };
}
/** Bounding squares enclose every phase, including the leader to a stationary endpoint. */
export function connectorOrbitBounds(start, end, orbit) {
    validateConnectorOrbit(orbit);
    const [a, b] = axes(orbit);
    return [start, end].flatMap((point, index) => {
        if (orbit.endpoints === (index === 0 ? 'to' : 'from'))
            return [point];
        const radius = Math.hypot(point[a] - orbit.center[a], point[b] - orbit.center[b]);
        return [-1, 1].flatMap(x => [-1, 1].map(y => {
            const corner = [...point];
            corner[a] = orbit.center[a] + radius * x;
            corner[b] = orbit.center[b] + radius * y;
            return corner;
        }));
    });
}
